import { Pose } from "./pose";

import { quat, vec3 } from "gl-matrix";

export type ActorId = number;

export interface ActorPoseCompressed {
  uid: number;
  rootPos: vec3;

  packedQuats: Uint32Array;
  nodeIds: Uint16Array;

  ground: number;
  apex: number;
  scale: number;

  frameNum?: number;
}

export interface ActorPoseWireLegacy {
  uid: number;
  rootId?: number;
  data: {
    [key: number]: number[];
  };
  ground: number;
  apex: number;
  scale: number;
}

// TODO: deprecate me
export class ActorPose {
  uid: number;
  // TODO: make private / readonly after construction
  poses: Record<number, Pose>;
  ground: number;
  apex: number;
  scale: number;

  rootPose?: Pose;
  rootId?: number;

  constructor(
    uid: number,
    data?: Record<number, Pose>,
    ground = 0,
    apex = 6,
    scale = 1
  ) {
    this.uid = uid;
    this.poses = data ?? {};
    this.ground = ground;
    this.apex = apex;
    this.scale = scale;

    for (const nodeIdStr of Object.keys(this.poses)) {
      const nodeId = Number.parseInt(nodeIdStr, 10);
      const pose = this.poses[nodeId];
      if (pose.pos) {
        if (this.rootPose) {
          console.warn(`multiple root poses found`);
        }
        this.rootPose = pose;
        this.rootId = nodeId;
      }

      if (quat.len(pose.quat) > 1.05) {
        console.error("INVALID QUAT HERE", pose.quat);
      }
    }

    if (!this.rootPose) {
      console.error("no root pose");
    }
  }

  static deserializeLegacy(wire: ActorPoseWireLegacy): ActorPose {
    // TODO: improve this
    const data: Record<number, Pose> = {};

    for (const jointId in wire.data) {
      if (!wire.data.hasOwnProperty(jointId)) continue;

      const pose = wire.data[jointId];
      const posePacked = pose as unknown as number[];

      const hasPos = posePacked.length > 4;
      const unpacked = new Pose(hasPos);
      if (hasPos) {
        unpacked.pos = [posePacked[0], posePacked[1], posePacked[2]];
        unpacked.quat = [
          posePacked[3],
          posePacked[4],
          posePacked[5],
          posePacked[6],
        ];
      } else {
        unpacked.quat = [
          posePacked[0],
          posePacked[1],
          posePacked[2],
          posePacked[3],
        ];
      }

      data[Number.parseInt(jointId, 10)] = unpacked;
    }

    return new ActorPose(wire.uid, data, wire.ground, wire.apex, wire.scale);
  }
}
